import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const MethodologyPhase = ({ phase, isActive, onToggle, index }) => {
  const [expandedSubPhase, setExpandedSubPhase] = useState(null);

  const phaseColors = {
    0: 'from-blue-500 to-blue-600',
    1: 'from-purple-500 to-purple-600', 
    2: 'from-green-500 to-green-600',
    3: 'from-orange-500 to-orange-600',
    4: 'from-red-500 to-red-600'
  };

  const toggleSubPhase = (subIndex) => {
    setExpandedSubPhase(expandedSubPhase === subIndex ? null : subIndex);
  };

  return (
    <div className={`bg-white rounded-xl shadow-executive border transition-all duration-300 ${
      isActive ? 'ring-2 ring-brand-primary shadow-executive-lg' : ''
    }`}>
      {/* Phase Header */}
      <div 
        className="p-6 cursor-pointer"
        onClick={onToggle}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className={`w-12 h-12 rounded-lg bg-gradient-to-r ${phaseColors?.[index]} flex items-center justify-center text-white font-bold text-lg`}>
              {index + 1}
            </div>
            <div>
              <h3 className="text-xl font-bold text-text-primary">{phase?.title}</h3>
              <p className="text-text-secondary text-sm">{phase?.duration}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <div className="text-sm font-medium text-text-primary">{phase?.deliverables?.length} Deliverables</div>
              <div className="text-xs text-text-secondary">{phase?.subPhases?.length} Sub-phases</div>
            </div>
            <Icon 
              name={isActive ? "ChevronUp" : "ChevronDown"} 
              size={20} 
              className="text-text-secondary"
            />
          </div>
        </div>
      </div>
      {/* Expanded Content */}
      {isActive && (
        <div className="px-6 pb-6 border-t border-gray-100">
          {/* Phase Description */}
          <div className="mb-6 pt-4">
            <p className="text-text-secondary leading-relaxed">{phase?.description}</p>
          </div>

          {/* Sub-phases */}
          <div className="mb-6">
            <h4 className="text-lg font-semibold text-text-primary mb-4">Sub-phases</h4>
            <div className="space-y-3">
              {phase?.subPhases?.map((subPhase, subIndex) => (
                <div key={subIndex} className="border border-gray-200 rounded-lg">
                  <div 
                    className="p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => toggleSubPhase(subIndex)}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center text-sm font-medium text-text-primary">
                          {subIndex + 1}
                        </div>
                        <div>
                          <h5 className="font-medium text-text-primary">{subPhase?.name}</h5>
                          <p className="text-sm text-text-secondary">{subPhase?.duration}</p>
                        </div>
                      </div>
                      <Icon 
                        name={expandedSubPhase === subIndex ? "ChevronUp" : "ChevronDown"} 
                        size={16} 
                        className="text-text-secondary"
                      />
                    </div>
                  </div>
                  
                  {expandedSubPhase === subIndex && (
                    <div className="px-4 pb-4 border-t border-gray-100">
                      <p className="text-sm text-text-secondary mt-3 leading-relaxed">{subPhase?.description}</p>
                      <div className="mt-3 flex flex-wrap gap-2">
                        {subPhase?.activities?.map((activity, actIndex) => (
                          <span 
                            key={actIndex}
                            className="px-3 py-1 bg-gray-100 text-xs font-medium text-text-primary rounded-full"
                          >
                            {activity}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Deliverables */}
          <div className="mb-6">
            <h4 className="text-lg font-semibold text-text-primary mb-4">Key Deliverables</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {phase?.deliverables?.map((deliverable, delIndex) => (
                <div key={delIndex} className="flex items-start space-x-3 p-3 bg-gray-50 rounded-lg">
                  <Icon name="CheckCircle" size={16} className="text-green-500 mt-0.5 flex-shrink-0" />
                  <div>
                    <h6 className="font-medium text-text-primary text-sm">{deliverable?.name}</h6>
                    <p className="text-xs text-text-secondary mt-1">{deliverable?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Success Metrics */}
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-4">Success Metrics</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {phase?.metrics?.map((metric, metIndex) => (
                <div key={metIndex} className="text-center p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg">
                  <div className="text-2xl font-bold text-brand-primary">{metric?.value}</div>
                  <div className="text-sm font-medium text-text-primary mt-1">{metric?.label}</div>
                  <div className="text-xs text-text-secondary mt-1">{metric?.description}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MethodologyPhase;